import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, CardContent } from '@material-ui/core';
import StripeAllChart from '../../organisms/SubStat/StripeAllChart';
import StripeYearTable from '../../organisms/SubStat/StripeYearTable';
// import OgoneAllChart from '../../organisms/SubStat/OgoneAllChart';
import OgoneCardChart from '../../organisms/SubStat/OgoneCardChart';
import PaymentWayTable from '../../organisms/SubStat/PaymentWayTable';
import settings from '../../settings';

const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1
  },
  block: {
    marginBottom: theme.spacing(2),
  },
  redirect: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignContent: 'center',
    gap: '8px',
    textAlign: 'center'
  },
}));

const SubStat = () => {
  const classes = useStyles();
  const history = useHistory();
  const [showOgoneStats, setShowOgoneStats] = useState(false);

  return (
    <div className={classes.container}>
      <div style={{ minHeight: '100vh' }}>
        <Card className={classes.block}>
          <CardContent>
            <div className={classes.redirect}>
              <Button variant="contained" onClick={() => history.push('/statistics-responsive')}>Statistiques responsive</Button>
              <Button variant="contained" href={settings.PaymentProvider.stripeDashboardUrl + 'dashboard'} target="_blank" rel="noreferrer">Statistiques Stripe</Button>
              {!!settings.PaymentProvider.profitwellUrl && <Button variant="contained" href={settings.PaymentProvider.profitwellUrl} target="_blank" rel="noreferrer">Statistiques Stripe avancées</Button>}
            </div>
          </CardContent>
        </Card>

        <StripeAllChart />
        <PaymentWayTable />
        <StripeYearTable />

        <Card className={classes.block}>
          <CardContent>
            <div className={classes.redirect}>
              <Button onClick={() => setShowOgoneStats(prev => !prev)} variant="contained" >Montrer les anciennes statistiques Ogone</Button>
            </div>
          </CardContent>
        </Card>

        {
          !!showOgoneStats && <>
            {/* <OgoneAllChart /> */}
            <OgoneCardChart />
          </>
        }
      </div>
    </div>
  );
}

export default SubStat;